<div class="flex flex-col gap-4">
  <div class="h-[290px] w-full rounded-xl px-1">
    @if (stepOrderRecord[activeStep()].video; as video) {
      <lib-video-player [videoOptions]="video" class="bg-black h-full w-full rounded-lg" />
    }
    @if (stepOrderRecord[activeStep()].imagePath; as imagePath) {
      <img [src]="imagePath" [alt]="stepOrderRecord[activeStep()].titleKey | translate" class="h-full w-full rounded-lg object-cover" />
    }
  </div>
  <div class="flex flex-col gap-4 px-4 pb-4">
    <div class="flex flex-col gap-4">
      <h2 class="typo-h2 font-semibold">{{ stepOrderRecord[activeStep()].titleKey | translate }}</h2>
      <div class="typo-h5-light h-20">
        {{ stepOrderRecord[activeStep()].descriptionKey | translate }}
      </div>
    </div>
    <div class="relative flex justify-between">
      <div class="z-10 flex items-center gap-2" [libUiTooltip]="dontShowAgainTooltip" [tooltipPosition]="'bottom'">
        <lib-checkbox [checked]="dontShowAgain()" (click)="setDontShowAgain()" />
        <span class="typo-h4-light min-w-max leading-[13px] text-text-primary">{{
          'perio_exam_tutorial_dont_show_again_label' | translate
        }}</span>
      </div>
      <div class="absolute flex h-full w-full items-center justify-center gap-1">
        @for (item of steps; track $index) {
          <button
            class="aspect-square h-2 w-2 rounded-full transition-colors"
            (click)="goToStep(item)"
            [ngClass]="{
              'bg-primary-blue': activeStep() === item,
              'bg-background-hover-blue': activeStep() !== item
            }"
          ></button>
        }
      </div>
      <div class="z-10 flex gap-2">
        <button
          class="typo-h5-semibold btn-secondary h-8 rounded-[13px] px-5 leading-[13px]"
          [disabled]="isFirstStep()"
          (click)="goToPreviousStep()"
        >
          {{ 'perio_exam_tutorial_back_button' | translate }}
        </button>
        @if (!isLastStep()) {
          <button class="typo-h5-semibold btn-primary h-8 w-[93px] rounded-[13px] px-5 leading-[13px]" (click)="goToNextStep()">
            {{ 'perio_exam_tutorial_next_button' | translate }}
            <svg-icon size="sm" key="px-24-arrow-right"></svg-icon>
          </button>
        } @else {
          <button
            class="typo-h5-semibold btn-primary h-8 w-[93px] justify-center rounded-[13px] px-5 leading-[13px]"
            (click)="closeTutorial()"
          >
            {{ 'perio_exam_tutorial_close_button' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
<ng-template #dontShowAgainTooltip>
  <span class="typo-">
    {{ 'perio_exam_tutorial_dont_show_again_tooltip' | translate }}
  </span>
</ng-template>
